module.exports = __webpack_public_path__ + "img/ico-percent-disabled.8dbbde1d.svg";